export const ADD_UNIT_SUCCESS = 'ADD_UNIT_SUCCESS';
export const FETCH_UNIT = 'FETCH_UNIT';
export const DELETE_UNIT_SUCCESS = 'DELETE_UNIT_SUCCESS';
export const EDIT_UNIT_SUCCESS = 'EDIT_UNIT_SUCCESS';
export const SET_SEARCH_UNIT = 'SET_SEARCH_UNIT';
export const CLEAR_SESSION = 'CLEAR_SESSION';
